import { useEffect, useState } from 'react';
import CrudTable from '../../components/CrudTable';
import { db } from '../../lib/supabase';
import { formatVND } from '../../lib/format';

export default function CombosAdmin() {
  const [products, setProducts] = useState([]);
  const [selected, setSelected] = useState(null); // combo row for item editing
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    db.list('products', { orderBy: 'name', ascending: true }).then(({ data }) => setProducts(data || []));
  }, []);

  const productOpts = products.map((p) => ({ value: p.id, label: p.name }));

  return (
    <div>
      <CrudTable
        title="🎁 Combo quà tặng"
        table="combos"
        defaults={{ active: true }}
        refreshKey={refreshKey}
        columns={[
          { key: 'name', label: 'Tên (VI)', type: 'text', required: true },
          { key: 'name_en', label: 'Tên (EN)', type: 'text', inTable: false },
          { key: 'description', label: 'Mô tả (VI)', type: 'textarea', inTable: false },
          { key: 'description_en', label: 'Mô tả (EN)', type: 'textarea', inTable: false },
          { key: 'price', label: 'Giá', type: 'number', required: true, render: (r) => formatVND(r.price) },
          { key: 'sale_price', label: 'Giá sale', type: 'number', render: (r) => (r.sale_price ? formatVND(r.sale_price) : '—') },
          { key: 'active', label: 'Đang bán', type: 'checkbox' },
        ]}
        rowActions={(row) => (
          <button className="btn btn-secondary btn-sm" onClick={() => setSelected(row)} title="Sản phẩm trong combo">🧺</button>
        )}
        afterChange={() => setRefreshKey((k) => k + 1)}
      />

      {selected && (
        <div style={{ marginTop: 28 }}>
          <div className="banner banner-yellow row spread">
            <span>Sản phẩm trong combo: <strong>{selected.name}</strong></span>
            <button className="btn btn-secondary btn-sm" onClick={() => setSelected(null)}>Đóng</button>
          </div>
          <CrudTable
            title={`🧺 Item của "${selected.name}"`}
            table="combo_items"
            orderBy="id"
            ascending
            match={{ combo_id: selected.id }}
            defaults={{ combo_id: selected.id, quantity: 1 }}
            columns={[
              { key: 'product_id', label: 'Sản phẩm', type: 'select', options: productOpts, required: true },
              { key: 'quantity', label: 'Số lượng', type: 'number', required: true },
            ]}
            emptyText='Combo chưa có sản phẩm nào — bấm Thêm mới.'
          />
        </div>
      )}
    </div>
  );
}
